export declare namespace PdfViewerTokenSections {
	interface Divider {
		color: string;
	}

	interface Canvas {
		background: string;
	}

	interface Thumbnail {
		current: {
			borderColor: string;
			background: string;
		};
		idle: {
			borderColor: string;
			hoverBorderColor: string;
		};
	}
}

export type PdfViewerTokens = {
	divider: PdfViewerTokenSections.Divider;
	canvas: PdfViewerTokenSections.Canvas;
	thumbnail: PdfViewerTokenSections.Thumbnail;
};

export const divider: PdfViewerTokenSections.Divider = { color: '{surface.300}' };

export const canvas: PdfViewerTokenSections.Canvas = { background: '{surface.200}' };

export const thumbnail: PdfViewerTokenSections.Thumbnail = {
	current: { borderColor: '{primary.500}', background: '{highlight.background}' },
	idle: { borderColor: 'transparent', hoverBorderColor: '{surface.300}' },
};

/** PDF viewer toolbar divider, canvas and page thumbnail colours (`css/pdfViewer`). */
export default {
	divider,
	canvas,
	thumbnail,
} satisfies PdfViewerTokens;
